export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20shopping%20flat%20lay%20with%20sneakers%20tote%20bag%20sunglasses%20and%20accessories%20on%20textured%20white%20linen%20fabric%2C%20soft%20golden%20sunlight%20casting%20warm%20glow%2C%20editorial%20lifestyle%20photography%2C%20aspirational%20shopping%20mood%2C%20elegant%20composition%20with%20gentle%20shadows&width=1600&height=700&seq=cta-hipobuy-v2&orientation=landscape"
              alt="Start shopping with Hipobuy Spreadsheet today"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/20"></div>
          </div>

          <div className="relative z-10 py-16 md:py-20 px-6 md:px-12 flex flex-col items-center text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-3 max-w-xl">
              Ready to Transform Your{' '}
              <span className="text-accent-300 font-heading italic">Shopping Research</span>?
            </h2>
            <p className="text-sm md:text-base text-background-200 mb-8 max-w-md">
              Join thousands of smart shoppers using Hipobuy Spreadsheet for faster, more organized product discovery
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm hover:bg-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                buy it now
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="#categories"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-background-50/60 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Browse All Categories
                <i className="ri-grid-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}